import styled from 'styled-components';
import { colors, spacing, WebLink2 } from 'ui/theme';
import { Modal, ModalBody } from 'ui/modal';

export const BorderedGreySection = styled.div`
  background-color: ${colors.grey1};
  border: solid ${spacing.single} ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.plusHalf};
  & > *:last-child:not(:first-child) {
    margin-top: ${spacing.base};
  }
`;

export const SpacedWebLink = styled(WebLink2)`
  align-items: center;
  display: inline-flex;
  & > * {
    margin-right: ${spacing.half};
  }
`;

export const StyledModal = styled(Modal)`
  overflow: initial;
`;

export const StyledModalBody = styled(ModalBody)<{ shouldOverflow: boolean }>`
  ${({ shouldOverflow }) => (!shouldOverflow ? 'overflow: initial' : '')};
`;
